export default {
    hiWelcomeBack: "ยินดีต้อนรับกลับมา ",
    dashboard: "แดชบอร์ด",
    currentPassword: "รหัสผ่านปัจจุบัน",
    password: "รหัสผ่าน",
    confirmPassword: "ยืนยันรหัสผ่าน",
    username: "ชื่อผู้ใช้",
    firstName: "ชื่อ",
    lastName: "นามสกุล",
    name: 'ชื่อ',
    contact: "เบอร์ติดต่อ",
    company: "วิสาหกิจ",
    companyName: "ชื่อบริษัท",
    email: 'อีเมล',
    address: "ที่อยู่",
    address1: "ที่อยู่บรรทัดที่ 1",
    address2: "ที่อยู่บรรทัดที่ 2",
    country: "ประเทศ",
    state: "จังหวัด",
    area: " พื้นที่",
    type: "พิมพ์",
    status: "สถานะ",
    postcode: "รหัสไปรษณีย์",
    location: "คลังสินค้า",
    branchName: "ชื่อสาขา",
    hq: "สำนักงานใหญ่",
    marking: "เครื่องหมายบรรจุภัณฑ์",
    markingList: 'รายการเครื่องหมายบรรจุภัณฑ์',
    markings: 'เครื่องหมายบรรจุภัณฑ์',
    customerMarkings: 'เครื่องหมายบรรจุภัณฑ์ลูกค้า',

    customers: "ลูกค้า",
    updateCustomer: "อัพเดทลูกค้า",
    branches: "กิ่งก้าน",
    branchDetailsInformation: "รายละเอียดสาขา ข้อมูล",
    supplier: "ผู้จัดส่ง",
    supplierName: 'ชื่อผู้จัดส่ง',
    supplierContact: 'ผู้ติดต่อผู้จัดส่ง',
    purchaseOrderNo: 'หมายเลขใบสั่งซื้อ',
    supplierPurchaseNo: "หมายเลขใบสั่งซื้อของผู้จัดส่ง",
    courierNo: "หมายเลขขนส่ง",
    model: "แบบอย่าง",
    items: "สินค้า",
    itemName: "ชื่อรายการ",
    handleQty: 'ปริมาณ',
    pcsCtn: 'จำนวน / ชิ้น',
    packUnit: 'การบรรจุ',
    cbm: 'ลูกบาศก์',
    tValue: 'มูลค่ารวม',
    tCbm: 'ปริมาตรรวม',
    tWeight: 'น้ำหนักรวม',
    code: 'รหัส',
    length: "ยาว",
    width: "ความกว้าง",
    height: "ความสูง",
    unitPrice: 'THB',

    changePassword: "เปลี่ยนรหัสผ่าน",
    changeCredential: "เปลี่ยนข้อมูลรับรอง",
    verifyAccountOwnership: "ยืนยันความเป็นเจ้าของบัญชี",

    containers: "คอนเทนเนอร์",
    newContainer: "เพิ่มคอนเทนเนอร์",
    updateContainer: "อัปเดตตู้คอนเทนเนอร์",
    roles: 'ตัวตน',

    selectCustomer: "เลือกลูกค้า",
    selectSupplier: "เลือกซัพพลายเออร์",

    loaded: 'ขึ้นตู้แล้ว',
    pending: 'ยังไม่ได้ขึ้นตู้',
    action: `ตัวเลือก`,
    remark: "หมายเหตุ",
    saveChanges: "บันทึก",
    back: "กลับ",
    paymentType: "ประเภทการชำระเงิน",

    systemId: 'รหัสระบบ',
    split: 'สินค้าแบ่งล็อต',
    splitId: `รหัสการแบ่งล็อต`,
    yes: 'ใช่',
    no: 'ไม่ใช่',
    isSplit: `แบ่งล็อต`,
    notSplit: `สินค้าเดิม`,

    basicSettings: "การตั้งค่าพื้นฐาน",
    advancedSettings: "การตั้งค่าขั้นสูง",
    customSettings: "การตั้งค่าอื่น ๆ",

    routeAdmin: `ผู้ดูแลระบบ`,
    routeWorkstation: `พนักงาน`,
    routeDriver: `คนขับรถ`,
    routeCustomer: `ลูกค้า`,
    routeRetail: `ผู้ค้าปลีก`,
    routeMember: `สมาชิก`,

    // ------ Listing ------
    createdAt: `เวลาที่สร้าง`,
    createdBy: `บัญชีผู้สร้าง`,
    createdDateTime: "เวลาที่สร้าง",
    updatedAt: `เวลาที่อัปเดต`,
    updatedBy: `บัญชีผู้แก้ไข`,
    updatedDateTime: "เวลาที่อัปเดต",

    dateFilter: 'ตัวกรองวันที่',
    fromDate: 'จากวันที่',
    toDate: 'ถึงวันที่',
    apply: 'ใช้'

}